import { execa, type Options as ExecaOptions } from 'execa';
import chalk from 'chalk';
import ora from 'ora';
import { CloudGridError } from '../../shared/src/errors.js';

// Re-export from shared package
export { TEMPLATES_DIR, SHARED_SERVICES_PATH } from '../../shared/src/paths.js';
export { CloudGridError };

// ── Verbose flag ────────────────────────────────────────────────

let _verbose = false;

export function setVerbose(v: boolean) { _verbose = v; }
export function isVerbose(): boolean { return _verbose; }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function exec(cmd: string, args: string[], opts?: ExecaOptions): Promise<any> {
  return execa(cmd, args, { ...opts, stdio: opts?.stdio ?? 'pipe' });
}

export async function execQuiet(cmd: string, args: string[]): Promise<string | null> {
  try {
    const result = await execa(cmd, args, { stdio: 'pipe' });
    return result.stdout;
  } catch {
    return null;
  }
}

export const log = {
  info: (msg: string) => console.log(chalk.blue('  ' + msg)),
  success: (msg: string) => console.log(chalk.green('  ' + msg)),
  warn: (msg: string) => console.log(chalk.yellow('  ' + msg)),
  error: (msg: string) => console.error(chalk.red('ERROR: ' + msg)),
  step: (msg: string) => console.log(chalk.gray('  ' + msg)),
};

export function spinner(text: string) {
  return ora({ text, color: 'cyan' });
}

export function die(msg: string): never {
  log.error(msg);
  throw new CloudGridError(msg);
}

export function upperSnake(name: string): string {
  return name.replace(/-/g, '_').toUpperCase();
}

export function parseEnvFile(content: string): Record<string, string> {
  const values: Record<string, string> = {};
  for (const line of content.split('\n')) {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith('#')) continue;
    const stripped = trimmed.startsWith('export ') ? trimmed.slice(7) : trimmed;
    const eq = stripped.indexOf('=');
    if (eq < 1) continue;
    let val = stripped.slice(eq + 1);
    if ((val.startsWith('"') && val.endsWith('"')) || (val.startsWith("'") && val.endsWith("'"))) {
      val = val.slice(1, -1);
    }
    values[stripped.slice(0, eq)] = val;
  }
  return values;
}
